// extracted by mini-css-extract-plugin
export default {"cls1":"BS959aeI0aYxTnmL2Ug7","cls2":"ZFJUlIGsR4OpMI89y71j BS959aeI0aYxTnmL2Ug7"};